module.exports = __webpack_public_path__ + "img/imgm.40a3efa9.png";